/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-08 17:36:01
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-10-19 18:00:57
 */
const STATUS = {
  0: "待上架",
  1: "已上架",
  2: "下架"
};
const STATUSTYPE = {
  0: '上架',
  1: '下架'
}
export default (Vue) => {
  return [
    {
      title: "商品名称",
      key: "name",
      minWidth: 180,
      align: 'center'
    },
    {
      title: "商品id",
      key: "productId",
      minWidth: 280,
      align: 'center'
    },
    {
      title: "售价",
      key: "price",
      align: 'center',
      minWidth: 100
    },
    {
      title: "原价",
      key: "originalPrice",
      align: 'center',
      minWidth: 100
    },
    {
      title: "真实销量",
      key: "realSalesVolume",
      align: 'center',
      minWidth: 80
    },
    {
      title: "状态",
      key: "isPublic",
      minWidth: 100,
      align: 'center',
      render: (h, { row }) => {
        const text = STATUS[String(row.isPublic)];
        return h('span', {
        }, text);
      }
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 200,
      render: (h, { row }) => {
        const text = STATUSTYPE[row.isPublic]
        return h('div', [
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                Vue.$refs.productadd.getEditData(row);
                Vue.showAdd = true;
              }
            }
          }, '编辑'),
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                Vue.$Modal.confirm({
                  title: `确定要${text}${row.name}么`,
                  loading: true,
                  onOk: async () => {
                    let status = row.isPublic == 0 ? 1 : 0;
                    Vue.$post("/product/editPublic", { id: row.id, productId: row.productId, isPublic: status }).then((da) => {
                      Vue.getProductList();
                      Vue.$Modal.remove();
                      Vue.$Notice.success({ title: `${text}成功` });
                    });
                  }
                });
              }
            }
          }, text),
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                Vue.$Modal.confirm({
                  title: `确定要删除${row.name}么`,
                  loading: true,
                  onOk: async () => {
                    Vue.$get("/product/delete", { productId: row.productId }).then((da) => {
                      Vue.getProductList();
                      Vue.$Modal.remove();
                      Vue.$Notice.success({ title: `${row.name}删除成功` });
                    });

                  }
                });
              }
            }
          }, '删除'),
        ]);
      }
    }
  ]
}